module.exports = __webpack_public_path__ + "static/media/15-jul19dec19.021a07c2.pdf";